import { ChangeDetectionStrategy, Component, EventEmitter, input, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { faUserGear, faUsers, faAddressCard, faCircleQuestion, faChevronRight, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { SummaryService } from 'src/app/services/summary.service';

@Component({
    selector: 'app-my-dashboard',
    templateUrl: './my-dashboard.component.html',
    styleUrls: ['./my-dashboard.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MyDashboardComponent implements OnInit {
  faUserGear = faUserGear;
  faUsers = faUsers;
  faAddressCard = faAddressCard;
  faCircleQuestion = faCircleQuestion;
  faChevronRight = faChevronRight;
  faLocationDot = faLocationDot;

  user = input.required<any>();
  @Output() changeIndex = new EventEmitter();
  type: any;

  summaryInfoSelected: any;
  currentYear = new Date().getFullYear();

  constructor(
    private readonly titleService: Title,
    private readonly summaryService: SummaryService
  ) {
    this.titleService.setTitle("BAER - My Dashboard");
  }

  ngOnInit(): void {
    
    this.summaryService.getSummary().subscribe((summaryInfo: any) => {
      this.setSummary(summaryInfo);
    })
  }

  setSummary(summaryInfo: any) {
    if (this.user().woOffice) {
      this.type = 'WO';
      this.summaryInfoSelected = summaryInfo.find((data: any) => data.discovery_year == this.currentYear && data.region == 'WO');
    } else if (this.user().regionOffice) {
      this.type = 'RO';
      this.summaryInfoSelected = summaryInfo.find((data: any) => data.discovery_year == this.currentYear && data.region == this.user().regionOffice.region && data.forest_name == 'region total');
    } else {
      this.type = 'FO';
      this.summaryInfoSelected = summaryInfo.find((data: any) => data.discovery_year == this.currentYear && data.region == this.user().forestOffice.region && data.forest_name == this.user().forestOffice.forest_name);
    }

    if (!this.summaryInfoSelected) { //set empty record since no assessments exist yet for the given selection
      this.summaryInfoSelected = {
        "plants": 0, "groundCover": 0, "channel": 0, "heritage": 0, "roads": 0, "trails": 0, "safety": 0, "monitoring": 0,
        "totalRequested": 0,
        "roAuth": 0, "woAuth": 0, "totalAuth": 0,
        "within2Weeks": 0,
        "pendingStartDate": 0,
        "preSizeUp": 0, "needed": 0, "noAssessment": 0, "inProgress": 0, "submitted": 0, "fundingAuthorized": 0, "teamLeadAssigned": 0,
        "fsAcresPreSizeUp": null, "fsAcresNeeded": null, "fsAcresNoAssessment": null, "fsAcresInProgress": null, "fsAcresSubmitted": null, "fsAcresFundingAuthorized": null, "fsAcresTeamLeadAssigned": null,
        "requestedFundsPreSizeUp": null, "requestedFundsNeeded": null, "requestedFundsNoAssessment": null, "requestedFundsInProgress": null, "requestedFundsSubmitted": null, "requestedFundsFundingAuthorized": null, "requestedFundsTeamLeadAssigned": null,
        "authFundsPreSizeUp": null, "authFundsNeeded": null, "authFundsNoAssessment": null, "authFundsInProgress": null, "authFundsSubmitted": null, "authFundsFundingAuthorized": null, "authFundsTeamLeadAssigned": null
      }
    }
  }

  indexChange(a:any) {
    this.changeIndex.emit('true');
  }
}